<template>

  <v-dialog v-model="dOpenComponente" persistent width="900px" content-class="">
    <v-card>
      <!-- cabecera del dialogo -->
      <v-toolbar dark class="datModalTitleContainer">
        <v-toolbar-title>
          {{ dInformeComponente.nombre }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon dark @click="fCerrarVentana()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-dialog v-model="dLoading" hide-overlay persistent width="300">
        <v-card class="datModalTitleContainer" dark>
          <v-card-text>
            {{ $t('cargandoContenido') }}
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-form ref="form" lazy-validation>
        <v-card-text>
          <v-flex xs12 class="pl-2 datModalSubtitle mb-3">
            {{ dInformeComponente.descripcion }}
          </v-flex>
          <!-- representantes -->
          <v-layout row wrap justify-space-between>
            <v-flex v-if="dRole !== 'CLIENTE'" xs12 sm5 px-2>
              <p class="datLabelGroup">
                {{ $t('Representante') }}
              </p>
              <DatTextFieldCodeSubfield ref="TablaDeRepresentantes" :pDataPass="dDataRepre" @select="fSelectRepre"
                @alert="fAlert" @clean="fCleanRepre"></DatTextFieldCodeSubfield>
            </v-flex>
            <v-flex v-if="dRole !== 'CLIENTE'" xs12 sm5 px-2>
              <p class="datLabelGroup">
                {{ $t('cliente') }}
              </p>
              <DatTextFieldCode ref="TablaDeClientes" :pDataPass="dDataClient" @select="fSelectClient" @alert="fAlert"
                @clean="fCleanClient"></DatTextFieldCode>
            </v-flex>
          </v-layout>

          <v-layout row wrap justify-space-between>
            <v-flex xs12 sm5 px-2>
              <p class="datLabelGroup">
                {{ $t('fechaVencimiento') }}
              </p>
              <v-menu ref="fechaIni" lazy :close-on-content-click="false" v-model="dDatosFechas.fechaIniVencMenu"
                transition="scale-transition" offset-y full-width :nudge-right="40" min-width="290px">
                <v-text-field clearable required color="datPrimary" slot="activator"
                  :label="this.$t('fechaInicialVencimiento')" v-model="dDatosFechas.fechaIniVencDateString"
                  append-icon="event" readonly :rules="[rules.checkfechasVencimientos]"></v-text-field>
                <v-date-picker :min="dDatosFechas.fechaMinIni" clearable color="datSecondary"
                  v-model="dDatosFechas.fechaIniVencDate" no-title scrollable :first-day-of-week="1" locale="es-es"
                  @input="$refs.fechaIni.save(dDatosFechas.fechaIniVencDate)">
                </v-date-picker>
              </v-menu>
              <v-menu ref="fechaFin" lazy :close-on-content-click="false" v-model="dDatosFechas.fechaFinVencMenu"
                transition="scale-transition" offset-y full-width :nudge-right="40" min-width="290px">
                <v-text-field clearable required color="datPrimary" slot="activator"
                  :label="this.$t('fechaFinalVencimiento')" v-model="dDatosFechas.fechaFinVencDateString"
                  append-icon="event" readonly :rules="[rules.checkfechasVencimientos]"></v-text-field>
                <v-date-picker :min="dDatosFechas.fechaMinFin" clearable color="datSecondary"
                  v-model="dDatosFechas.fechaFinVencDate" no-title scrollable :first-day-of-week="1" locale="es-es"
                  @input="$refs.fechaFin.save(dDatosFechas.fechaFinVencDate)">
                </v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs12 sm5 px-2>
              <p class="datLabelGroup">
                {{ $t('fechaFactura') }}
              </p>
              <v-menu ref="fechaIniFactura" lazy :close-on-content-click="false"
                v-model="dDatosFechas.fechaIniFacturaMenu" transition="scale-transition" offset-y full-width
                :nudge-right="40" min-width="290px">
                <v-text-field clearable required color="datPrimary" slot="activator"
                  :label="this.$t('fechaInicialFactura')" v-model="dDatosFechas.fechaIniFacturaDateString"
                  append-icon="event" readonly :rules="[rules.checkfechasFacturas]"></v-text-field>
                <v-date-picker clearable color="datSecondary" v-model="dDatosFechas.fechaIniFacturaDate" no-title
                  scrollable :first-day-of-week="1" locale="es-es"
                  @input="$refs.fechaIniFactura.save(dDatosFechas.fechaIniFacturaDate)">
                </v-date-picker>
              </v-menu>
              <v-menu ref="fechaFinFactura" lazy :close-on-content-click="false"
                v-model="dDatosFechas.fechaFinFacturaMenu" transition="scale-transition" offset-y full-width
                :nudge-right="40" min-width="290px">
                <v-text-field clearable required color="datPrimary" slot="activator"
                  :label="this.$t('fechaFinalFactura')" v-model="dDatosFechas.fechaFinFacturaDateString"
                  append-icon="event" readonly :rules="[rules.checkfechasFacturas]"></v-text-field>
                <v-date-picker clearable color="datSecondary" v-model="dDatosFechas.fechaFinFacturaDate" no-title
                  scrollable :first-day-of-week="1" locale="es-es"
                  @input="$refs.fechaFinFactura.save(dDatosFechas.fechaFinFacturaDate)">
                </v-date-picker>
              </v-menu>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions class="py-3 transparent">
          <v-flex xs12 pr-3 class="text-xs-right">
            <v-btn class="datPrimaryBtnOut" flat @click="fLimpiaFiltros()">{{ $t('limpiar') }}</v-btn>
            <v-btn class="datPrimaryBtn" flat @click="fDescargarInforme()" :disabled="dDisableDescarga">
              {{ dDescargarTxt }}
            </v-btn>
          </v-flex>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>

import DatTextFieldCode from '@/components_datadec/DatTextFieldCode'
import DatTextFieldCodeSubfield from '@/components_datadec/DatTextFieldCodeSubfield'
import { generarPdf, abrirPestanaEnBlanco, abrirPdfEnPestanaPreabierta } from '@/utils/utilDescargarPdf'

// SERVICES

import SrvImpresion from '@/services/srv-impresion'

export default {
  name: 'ShpFiltroCobrosPendientes',
  components: {
    DatTextFieldCode,
    DatTextFieldCodeSubfield
  },
  props: {
    pInformeComponente: {
      type: Object,
      required: true
    },
    pLimitDate: {
      type: Object,
      required: false,
      default: {}
    }
  },
  data() {
    return {
      dFormatString: {
        'default': 'DD/MM/YYYY',
        'years': 'YYYY-MM-DD'
      },
      dRowsPerPage: 5,
      dDescargarTxt: this.$t('descargar'),
      dDisableDescarga: false,
      dLoading: false,
      dRole: '',
      dOpenComponente: true,
      dInformeComponente: null,
      dSelectClient: { codigo: '', nombre: '' },
      dRequestClient: { empresa: this.$store.getters.getAutenticacion.empresa },
      dSelectRepre: { codigo: '', subfield: '', nombre: '' },
      dRequestRepre: { empresa: this.$store.getters.getAutenticacion.empresa, pasivo: 'N' },
      dRequestRepreSec: {},
      dDataClient: {},
      dDataRepre: {},
      dDatosFechas: {
        'fechaIniVencMenu': false,
        'fechaIniVencDate': '',
        'fechaIniVencDateString': '',
        'fechaMinIni': '',
        'fechaFinVencMenu': false,
        'fechaFinVencDate': '',
        'fechaFinVencDateString': '',
        'fechaMinFin': '',
        'fechaIniFacturaMenu': false,
        'fechaIniFacturaDate': '',
        'fechaIniFacturaDateString': '',
        'fechaFinFacturaMenu': false,
        'fechaFinFacturaDate': '',
        'fechaFinFacturaDateString': ''
      },
      rules: {
        /*
         * Regla para comprobar fecha de creacion
         */
        checkfechasVencimientos: (value) => {
          if ((this.dDatosFechas.fechaIniVencDateString !== undefined) && (this.dDatosFechas.fechaFinVencDateString !== undefined) &&
            (this.dDatosFechas.fechaIniVencDateString !== null) && (this.dDatosFechas.fechaFinVencDateString !== null) &&
            (this.dDatosFechas.fechaIniVencDateString !== '') && (this.dDatosFechas.fechaFinVencDateString !== '')) {
            const fechaIniVencDate = this.$moment(this.dDatosFechas.fechaIniVencDateString)
            const fechaFinVencDate = this.$moment(this.dDatosFechas.fechaFinVencDateString, this.dFormatString.default)
            if (fechaIniVencDate <= fechaFinVencDate) {
              return true
            } else {
              return this.$t('fechaInicialMayorFinal')
            }
          } else {
            return true
          }
        },
        /*
         * Regla para comprobar fecha de creacion
         */
        checkfechasFacturas: (value) => {
          if ((this.dDatosFechas.fechaIniFacturaDateString !== undefined) && (this.dDatosFechas.fechaFinFacturaDateString !== undefined) &&
            (this.dDatosFechas.fechaIniFacturaDateString !== null) && (this.dDatosFechas.fechaFinFacturaDateString !== null) &&
            (this.dDatosFechas.fechaIniFacturaDateString !== '') && (this.dDatosFechas.fechaFinFacturaDateString !== '')) {
            const fechaIniFacturaDate = this.$moment(this.dDatosFechas.fechaIniFacturaDateString, this.dFormatString.default)
            const fechaFinFacturaDate = this.$moment(this.dDatosFechas.fechaFinFacturaDateString, this.dFormatString.default)
            if (fechaIniFacturaDate <= fechaFinFacturaDate) {
              return true
            } else {
              return this.$t('fechaInicialMayorFinal')
            }
          } else {
            return true
          }
        }
      }
    }
  },
  watch: {
    /*
     * Espera el cambio de la fecha para cambiar el formato
     */
    'dDatosFechas.fechaIniVencDate': function (val, oldVal) {
      // formateo fechas
      if (val !== null) {
        this.dDatosFechas.fechaIniVencDateString = this.$moment(val, this.dFormatString.years).format(this.dFormatString.default)
      }
    },
    /*
     * Espera el cambio de la fecha para cambiar el formato
     */
    'dDatosFechas.fechaFinVencDate': function (val, oldVal) {
      // formateo fechas
      if (val !== null) {
        this.dDatosFechas.fechaFinVencDateString = this.$moment(val, this.dFormatString.years).format(this.dFormatString.default)
      }
    },
    /*
     * Espera el cambio de la fecha para cambiar el formato
     */
    'dDatosFechas.fechaIniFacturaDate': function (val, oldVal) {
      // formateo fechas
      if (val !== null) {
        this.dDatosFechas.fechaIniFacturaDateString = this.$moment(val, this.dFormatString.years).format(this.dFormatString.default)
      }
    },
    /*
     * Espera el cambio de la fecha para cambiar el formato
     */
    'dDatosFechas.fechaFinFacturaDate': function (val, oldVal) {
      // formateo fechas
      if (val !== null) {
        this.dDatosFechas.fechaFinFacturaDateString = this.$moment(val, this.dFormatString.years).format(this.dFormatString.default)
      }
    }
  },
  created() {
    this.fLimitFechas()
    this.fIniciarVariables()
    // Inicializa las variables locales
    this.dInformeComponente = this.pInformeComponente
  },
  methods: {
    fIniciarVariables() {
      let isRepre = false
      this.dRole = this.pLimitDate.roleUser
      this.fAssignedRole()
      if (this.dRole === 'REPRESENTANTE') {
        isRepre = true
        this.dRequestRepreSec = {
          empresa: this.$store.getters.getAutenticacion.empresa,
          representante: this.$store.getters.getAutenticacion.representante,
          agente: this.$store.getters.getAutenticacion.agente
        }
      }
      this.dDataRepre = {
        'errorMessages': [],
        'labelMainField': 'codigo',
        'labelSubField': 'agente',
        'label': 'representanteInicial',
        'rowsPerPage': this.dRowsPerPage,
        'headers': [
          { text: this.$t('Representante'), align: 'left', value: 'codigo', column: 'representante' },
          { text: this.$t('agente'), align: 'left', value: 'subfield', column: 'agente' },
          { text: this.$t('nombreRepresentante'), align: 'left', value: 'nombre', column: 'nombre' }
        ],
        'urlWS': 'lovRep',
        'headersSec': [
          { text: this.$t('Representante'), align: 'left', value: 'codigo', column: 'REP_REPRESENTANTE' },
          { text: this.$t('agente'), align: 'left', value: 'subfield', column: 'REP_AGENTE' },
          { text: this.$t('nombreRepresentante'), align: 'left', value: 'nombre', column: 'REP_NOMBRE' }
        ],
        'filtersSec': { 'codigo': 'REP_REPRESENTANTE', 'subfield': 'REP_AGENTE', 'nombre': 'REP_NOMBRE' },
        'defaultSec': { 'codigo': '', 'subfield': '', 'nombre': '' },
        'isSec': isRepre,
        'urlSec': 'getRepres',
        'requestSec': this.dRequestRepreSec,
        'orderByDefaultSec': 'REP_REPRESENTANTE',
        'item': { 'codigo': '', 'subfield': '', 'nombre': '' },
        'request': this.dRequestRepre,
        'filters': { 'codigo': 'representante', 'subfield': 'agente', 'nombre': 'nombre' },
        'resultName': 'dataRes',
        'default': this.dSelectRepre,
        'disabled': false,
        'required': false,
        'title': 'selectRepresentante',
        'isVisibleLoad': true,
        'orderByDefault': 'representante',
        'orderDefault': 'ASC'
      }
      this.dDataClient = {
        'errorMessages': [],
        'label': 'clienteInicial',
        'rowsPerPage': this.dRowsPerPage,
        'headers': [
          { text: this.$t('cliente'), align: 'left', value: 'codigo', column: 'cliente' },
          { text: this.$t('nombreCliente'), align: 'left', value: 'nombre', column: 'nombre' }
        ],
        'urlWS': 'lovClte',
        'item': { 'codigo': '', 'nombre': '' },
        'filters': { 'codigo': 'cliente', 'nombre': 'nombre' },
        'resultName': 'dataRes',
        'request': this.dRequestClient,
        'default': this.dSelectClient,
        'disabled': false,
        'required': false,
        'orderByDefault': 'cliente',
        'orderDefault': 'ASC',
        'isVisibleLoad': true,
        'textCodigo': 'codigo',
        'title': 'seleccionaUnCliente'
      }
    },
    fSelectRepre(item) {
      if (item && item != null) {
        this.dSelectRepre.codigo = item.codigo
        this.dSelectRepre.subfield = item.subfield
        this.dSelectRepre.nombre = item.nombre
      }
    },
    fSelectClient(item) {
      if (item && item != null) {
        this.dSelectClient.codigo = item.codigo
        this.dSelectClient.nombre = item.nombre
      }
    },
    fCleanRepre() {
      this.dSelectRepre = {}
    },
    fCleanClient() {
      this.dSelectClient = {}
    },
    fAlert(msg) {
      this.$emit('alert', msg)
    },
    /**
     * Metodo para cerrar la ventana
     */
    fCerrarVentana() {
      this.fLimpiaFiltros()
      this.$emit('close')
    },
    fAssignedRole() {
      switch (this.dRole) {
        case 'CLIENTE':
          this.dSelectClient.codigo = this.$store.getters.getAutenticacion.cliente
          break
        case 'REPRESENTANTE':
          this.dSelectRepre.codigo = this.$store.getters.getAutenticacion.representante
          this.dSelectRepre.nombre = this.$store.getters.getAutenticacion.representanteNombre
          this.dSelectRepre.subfield = this.$store.getters.getAutenticacion.agente
          break
        default:
      }
    },
    /**
     * Metodo de limpieza de los filtros
     */
    fLimpiaFiltros() {
      if (this.dRole === 'ADMIN') {
        this.dSelectRepre = { codigo: '', nombre: '' }
        if (this.$refs.TablaDeRepresentantes) {
          this.$refs.TablaDeRepresentantes.fActualizarItem(this.dSelectRepre)
        }
      }
      if (this.dRole === 'ADMIN' || this.dRole === 'REPRESENTANTE') {
        this.dSelectClient = { codigo: '', nombre: '' }
        if (this.$refs.TablaDeClientes) {
          this.$refs.TablaDeClientes.fActualizarItem(this.dSelectClient)
        }
      }

      this.dDatosFechas.fechaIniVencMenu = false
      this.dDatosFechas.fechaIniVencDate = null
      this.dDatosFechas.fechaIniVencDateString = null

      this.dDatosFechas.fechaFinVencMenu = false
      this.dDatosFechas.fechaFinVencDate = null
      this.dDatosFechas.fechaFinVencDateString = null

      this.dDatosFechas.fechaIniFacturaMenu = false
      this.dDatosFechas.fechaIniFacturaDate = null
      this.dDatosFechas.fechaIniFacturaDateString = null

      this.dDatosFechas.fechaFinFacturaMenu = false
      this.dDatosFechas.fechaFinFacturaDate = null
      this.dDatosFechas.fechaFinFacturaDateString = null
    },
    /**
     * Metodo de descarga del informes
     */
    fAssignedFilters(jsonEntrada) {
      // Check role para mostrar busqueda por representante
      jsonEntrada.repIni = ''
      jsonEntrada.repFin = ''
      if ((this.dSelectRepre !== undefined) && (this.dSelectRepre.codigo !== '') && (this.dSelectRepre.codigo !== undefined)) {
        jsonEntrada.repIni = String(this.dSelectRepre.codigo)
        jsonEntrada.repFin = String(this.dSelectRepre.codigo)
      }

      // Check role para mostrar busqueda por cliente
      jsonEntrada.ClienteIni = ''
      jsonEntrada.ClienteFin = ''

      if ((this.dSelectClient !== undefined) && (this.dSelectClient.codigo !== '') && (this.dSelectClient.codigo !== undefined)) {
        jsonEntrada.ClienteIni = String(this.dSelectClient.codigo)
        jsonEntrada.ClienteFin = String(this.dSelectClient.codigo)
      }

      jsonEntrada.fechaIniVencimiento = (this.dDatosFechas.fechaIniVencDateString !== null && this.dDatosFechas.fechaIniVencDateString !== '') ? this.dDatosFechas.fechaIniVencDateString : ''
      jsonEntrada.fechaFinVencimiento = (this.dDatosFechas.fechaFinVencDateString !== null && this.dDatosFechas.fechaFinVencDateString !== '') ? this.dDatosFechas.fechaFinVencDateString : ''
      jsonEntrada.fechaIniFactura = (this.dDatosFechas.fechaIniFacturaDateString !== null && this.dDatosFechas.fechaIniFacturaDateString !== '') ? this.dDatosFechas.fechaIniFacturaDateString : ''
      jsonEntrada.fechaFinFactura = (this.dDatosFechas.fechaFinFacturaDateString !== null && this.dDatosFechas.fechaFinFacturaDateString !== '') ? this.dDatosFechas.fechaFinFacturaDateString : ''
    },
    fDescargarInforme() {
      const ventanaPdf = abrirPestanaEnBlanco()
      this.dDescargarTxt = this.$t('descargar')
      this.dLoading = true
      this.dDisableDescarga = true
      this.fDescargandoInforme()
      // prepara los parametros generales de busqueda
      const jsonEntrada = {
        tira: this.$store.getters.getAutenticacion.tira,
        empresa: this.$store.getters.getAutenticacion.empresa,
        tipoEmpresa: '0',
        pdfSn: 'S'
      }
      // Parametros formulario ESTADO VENCIMIENTOS

      jsonEntrada.SituacionInforme = 'IMPAGADO'
      jsonEntrada.TipoSeleccionRepresentante = 'E'

      // Asignar Filtros
      this.fAssignedFilters(jsonEntrada)

      if (this.fCheckFiltrosPendientes()) {
        SrvImpresion.carteraSitCobros(jsonEntrada).then(response => {
          if (this.fRespuestaCorrecta(response)) {
            if (response.data.report !== '') {
              abrirPdfEnPestanaPreabierta(generarPdf(response.data.report), ventanaPdf)
            } else {
              if (ventanaPdf && !ventanaPdf.closed) {
                ventanaPdf.close()
              }
              this.$emit('alert', '<b>' + this.$t('estadoVentaNotFound') + '</b><br> ' + this.$t('estadoVentaNotFoundDesc'))
            }
          } else {
            if (ventanaPdf && !ventanaPdf.closed) {
              ventanaPdf.close()
            }
            this.$emit('alert', '<b>' + this.$t('errorDefault') + '</b><br> ' + this.$t('errorDefaultDesc'))
          }
          this.dLoading = false
          this.dDisableDescarga = false
          this.dDescargarTxt = this.$t('descargar')
        }).catch(error => {
          if (ventanaPdf && !ventanaPdf.closed) {
            ventanaPdf.close()
          }
          this.fErrorComprobado(error.response)
          this.dLoading = false
          this.dDescargarTxt = this.$t('descargar')
          this.dDisableDescarga = false
        })
      } else {
        if (ventanaPdf && !ventanaPdf.closed) {
          ventanaPdf.close()
        }
        this.$emit('alert', this.$t('avisoFactura') + '<br/>' + this.$t('avisoFacturaDesc'))
        this.dDescargarTxt = this.$t('descargar')
        this.dLoading = false
        this.dDisableDescarga = false
      }
    },
    fDescargandoInforme() {
      this.dDisableDescarga = true
      this.dDescargarTxt = this.$t('enPreparacion')
    },
    /**
     * comprueba si falta recibir información de algun filtro
     */
    fCheckFiltrosPendientes() {
      return ((this.dSelectClient !== undefined && this.dSelectClient.codigo) || (this.dSelectRepre !== undefined && this.dSelectRepre.codigo))
    },
    fLimitFechas() {
      if (this.pLimitDate.fechaIniLimit !== '' && this.pLimitDate.fechaIniLimit !== null) {
        this.dDatosFechas.fechaMinIni = this.$moment(this.pLimitDate.fechaIniLimit, this.dFormatString.years).format(this.dFormatString.years)
      }
      if (this.pLimitDate.fechaFinLimit !== '' && this.pLimitDate.fechaFinLimit !== null) {
        this.dDatosFechas.fechaMinFin = this.$moment(this.pLimitDate.fechaFinLimit, this.dFormatString.years).format(this.dFormatString.years)
      }
    },
    fRespuestaCorrecta(response) {
      let finalvalue = false;
      if (response.status === 200 && response.data.result !== 'ko' && (response || response.data !== undefined || response.data.dataRes.result !== undefined || response.data.dataRes.result !== null)) {
        finalvalue = true;
      }
      return finalvalue;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.buttonBar .card__title {
  padding: 8px !important;
}

.buttonBarSearch .card__title {
  padding: 0px !important;
}

.buttonBarSearchTop .card__text {
  padding-top: 4px !important;
  padding-bottom: -10px !important;
}

.numberInputSpinnerInput .vnis__input {
  background: #ffffff !important;
  border: 0px !important;
  border-bottom: 1px solid #999999 !important;
}

.numberInputSpinnerButton .vnis__button {
  background: #ffffff !important;
  color: #000000 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Informes/Cobros/ShpFiltroCobrosPendientes.vue